function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M21.63 13.7a2.79 2.79 0 1 1 0-5.58 2.79 2.79 0 0 1 0 5.58zm0-.75a2.04 2.04 0 1 0 0-4.08 2.04 2.04 0 0 0 0 4.08zM1 4.2l.87-1.07h10.35l1.33 1.09L1 4.2zm5.63 9.49a2.79 2.79 0 1 1 0-5.58 2.79 2.79 0 0 1 0 5.58zm0-.75a2.04 2.04 0 1 0 0-4.08 2.04 2.04 0 0 0 0 4.08zm33.2.75a2.79 2.79 0 1 1 0-5.58 2.79 2.79 0 0 1 0 5.58zm0-.75a2.04 2.04 0 1 0 0-4.08 2.04 2.04 0 0 0 0 4.08z"
}), React.createElement("path", {
  d: "M43.22 11.74c.07-1.59-.68-4.13-3.37-4.13s-3.66 2.34-3.4 4.08l-11.52.01c.12-2-.6-4.02-3.3-4.02-2.7 0-3.24 1.84-3.26 3.95l-2.12-.01s-.9-.6-.9-.89h-1.8v.89s-2.73.03-3.5 0C10 10.48 9.6 7.71 6.6 7.7c-3-.01-3.37 2.55-3.33 3.88-.9 0-2.28.04-2.28.04V4.54h12.55v4.42h1.8V5.42h3.59L22.52 1h8.97l7.17 4.42s3.33-.08 4.14-.01c2.63.95 3.2 2.69 3.2 3.57v2.73c-.45.02-.1.03-2.78.03zM29.79 1.88v3.54h6.18L30.9 1.88h-1.11zm-7.2 1.77s-.86.96-.6 1.46c1.03.24 1.5.31 1.5.31H28V1.88h-3.6l-1.8 1.77z"
}));

var SvgVehicleLongAndLow = function SvgVehicleLongAndLow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 47,
    height: 15,
    viewBox: "0 0 47 15",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleLongAndLow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-long-and-low.f7bd2759.svg";
export { ForwardRef as ReactComponent };